import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTw = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1925_44767)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.99951 0.758067C4.89547 0.758067 0.757854 4.89569 0.757854 9.99973C0.757854 15.1038 4.89547 19.2414 9.99951 19.2414C15.1035 19.2414 19.2412 15.1038 19.2412 9.99973C19.2412 4.89569 15.1035 0.758067 9.99951 0.758067ZM-0.000488281 9.99973C-0.000488281 4.47687 4.47665 -0.000274658 9.99951 -0.000274658C15.5224 -0.000274658 19.9995 4.47687 19.9995 9.99973C19.9995 15.5226 15.5224 19.9997 9.99951 19.9997C4.47665 19.9997 -0.000488281 15.5226 -0.000488281 9.99973Z",
			fill: "#565CDE"
		}), /* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip1_1925_44767)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M10.9309 9.23438L14.5735 5H13.7102L10.5474 8.67656L8.02117 5H5.10742L8.92758 10.5597L5.10742 15H5.9707L9.31086 11.1174L11.9787 15H14.8924L10.9306 9.23438H10.9309ZM9.74852 10.6086L9.36141 10.055L6.28172 5.64984H7.60766L10.0929 9.205L10.4799 9.75859L13.7106 14.3797H12.3848L9.74852 10.6088V10.6086Z",
				fill: "#565CDE"
			})
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1925_44767",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_1925_44767",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 10,
			height: 10,
			fill: "white",
			transform: "translate(5 5)"
		})
	})] })]
});
export default SvgTw;
